<template>
  <div class="wapper">
    <el-page-header @back="goBack" content="提成方案详情" class="header" v-if="!status"></el-page-header>
    <div class="content-wapper" v-if="null != info">
      <!-- <DetailHeader @submit="submit" :params="editParams" v-if="status == 1"></DetailHeader> -->
      <div class="success-wapper" v-if="status">
        <img src="@/assets/u97.png" alt="success">
        <p>方案提交成功，你可以 <span class="link" @click="goList">返回列表页</span></p>
        <p>以下为方案详情，请仔细核对，如需要修改请点击 <span class="link" @click="goEait">返回编辑</span></p>
      </div>
      <div v-if="!status">
        <Foundation :info="info" :status="status" />
        <div class="images-wapper">
          <PlanTable :info="info" v-if="info.conditionMethod==1" />
          <ExtraTable :info="info" v-if="info.conditionMethod==2" />
        </div>
      </div>
      <div v-else>
        <div class="images-wapper">
          <PlanTable :info="info" v-if="info.conditionMethod==1" />
          <ExtraTable :info="info" v-if="info.conditionMethod==2" />
        </div>
        <Foundation :info="info" :status="status" />
      </div>
      <div class="images-wapper">
        <span class="title">可开票内容信息</span>
        <div class="table-wapper">
          <label>可开票内容列表</label>
          <table>
            <tr>
              <td>编号</td>
              <td>内容名称</td>
            </tr>
            <tr v-for="item in info.invoiceList" :key="item.id">
              <td>{{ item.invoiceContentId }}</td>
              <td>{{ item.invoiceName }}</td>
            </tr>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import _pointsPlan from '@/service/points-plan-service'
import PlanTable from './common/planTable.vue'
import Foundation from './common/foundation.vue'
import ExtraTable from './common/extraTable.vue'
import _royaltyPlan from '../../service/royalty-plan-service'
export default {
  components: {
    PlanTable,
    Foundation,
    ExtraTable
  },
  data() {
    return {
      id: this.$route.query.id,
      info: null,
      editParams: {
        path: '/add-points-plan',
        query: {
          id: this.$route.query.id
        }
      },
      status: this.$route.query.status,
    }
  },
  mounted() {
    this.getInfo()
  },
  methods: {
    goList() {
      this.$router.push({
        path: '/points-plan-list'
      })
    },
    goBack(){
      this.$router.back()
    },
    goEait() {
      this.$router.push({
        path: '/add-points-plan',
        query:{
          id:this.id,
        }
      })
    },
    getInfo() {
      _pointsPlan.pointsPlanDetalis(this.id, response => {
        this.info = response
        if(this.info.optionsMap){
          let optionList = {
            fieldName: null,
            conditions: []
          }
          for (const item in this.info.optionsMap) {
            optionList.fieldName = item
            this.info.optionsMap[item].forEach(row=>{
              optionList.conditions.push(row)
            })
          }
          this.info.optionList = optionList
        }
        console.log(this.info, 'this.info');

      })
    },
    submit() {
      _royaltyPlan.updateVisibility({
        id: this.id,
        delFlag: 1,
      },res=>{
        this.$router.push({
          path: '/points-plan-success',
          query: {
            id: this.id,
          }
      })
      },err=>{
        this.$notify({
          message:err,
          type: 'warning'
        });
      })
    }
  },
  // 路由前置守卫
  beforeRouteEnter(to, from, next) {
    // 检查必要的查询参数
    if (to.query.status == 1) {
      to.meta.isStep = true
    }
    if (to.query.status != 1) {
      to.meta.isStep = false
    }
    next()
  },
}
</script>

<style scoped>
.link{
  color: #409EFF;
  cursor: pointer;
}
.success-wapper{
  text-align: center;
}
.success-wapper p{
  text-align: center;
  font-size: 16px;
  margin-top: 22px;
}
</style>